import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-youtube-help-video",
  templateUrl: "./youtube-help-video.component.html",
  styleUrls: ["./youtube-help-video.component.scss"],
})
export class YoutubeHelpVideoComponent implements OnInit {

  videoSrc: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<YoutubeHelpVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    let rawUrl = this.data.qsDescription;
    let embedUrl = this.convertToEmbedUrl(rawUrl);

    this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  // ⭐ Converts ANY YouTube URL → EMBED format
  private convertToEmbedUrl(url: string): string {
    // Case 1: youtu.be short form
    if (url.includes("youtu.be/")) {
      const id = url.split("youtu.be/")[1];
      return `https://www.youtube.com/embed/${id}`;
    }

    // Case 2: watch?v= format
    if (url.includes("watch?v=")) {
      const id = url.split("watch?v=")[1];
      return `https://www.youtube.com/embed/${id}`;
    }

    // Case 3: Already an embed link
    if (url.includes("youtube.com/embed")) {
      return url;
    }

    // Case 4: Raw ID only
    if (url.length === 11 && !url.includes("http")) {
      return `https://www.youtube.com/embed/${url}`;
    }

    // Default fallback
    return url;
  }

  private extractVideoId(url: string): string {

  // Case 1: youtu.be short URL
  if (url.includes("youtu.be/")) {
    return url.split("youtu.be/")[1].split("?")[0];
  }

  // Case 2: watch?v=
  if (url.includes("watch?v=")) {
    return url.split("watch?v=")[1].split("&")[0];
  }

  // Case 3: embed link
  if (url.includes("embed/")) {
    return url.split("embed/")[1].split("?")[0];
  }

  // Case 4: raw ID (length 11)
  if (url.length === 11 && !url.includes("http")) {
    return url;
  }

  return ""; // fallback
}

}






// import { Component, Inject, OnInit, SecurityContext } from "@angular/core";
// import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
// import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

// @Component({
//   selector: "app-youtube-help-video",
//   templateUrl: "./youtube-help-video.component.html",
//   styleUrls: ["./youtube-help-video.component.scss"],
// })
// export class YoutubeHelpVideoComponent implements OnInit {
//   videoSrc: SafeUrl;

//   constructor(
//     protected _sanitizer: DomSanitizer,
//     public dialogRef: MatDialogRef<YoutubeHelpVideoComponent>,
//     @Inject(MAT_DIALOG_DATA) public data: any
//   ) {}

//   ngOnInit() {
//     if (this.data.qsCode == "Q_AADHAR" && +this.data.pkQsid == 2) {
//       let url = this.data.qsDescription.split(",")[0];
//       this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(url);
//     } else {
//       let url = this.data.qsDescription;
//       this.videoSrc = this._sanitizer.bypassSecurityTrustResourceUrl(url);
//     }
//   }
// }




